var $ = require('jquery');
(function() {

    /**
     * Detect an Object.create issue on IE9-11. Code taken from https://codereview.appspot.com/91140043/
     * See below for details. This bug manifests when using angular.copy in Angular 1.3.0
     * which uses Object.create internally, breaking theming
     */

    /**
     * Bug in IE versions 9 to 11 (current as of this writing):
     * http://webreflection.blogspot.co.uk/2014/04/all-ie-objects-are-broken.html
     *
     * An object which is a product of Object.create(somePrototype), and which has
     * only numeric-named properties, will in some ways appear to not have those
     * properties.
     *
     * Fixed with http://support.microsoft.com/kb/2980015
     */
    function test_NUMERIC_PROPERTIES_INVISIBLE() {
        var o1 = Object.create({}, {0: {value: 1}});  // normal
        var o2 = Object.create({});                   // demonstrates bug
        o2[0] = 1;

        if (o1.hasOwnProperty('0') && o1[0] === 1 &&
            o2.hasOwnProperty('0') && o2[0] === 1) {
            return false;
        } else if (o1.hasOwnProperty('0') && o1[0] === 1 &&
            !o2.hasOwnProperty('0') && o2[0] === 1) {
            return true;
        } else {
            return 'Unexpected results from numeric property on created object';
        }
    }

    if (test_NUMERIC_PROPERTIES_INVISIBLE()) {
        $(document).ready(function() {
            $('<div></div>')
                .appendTo('body')
                .html(jimdoData.messages.windowsupdate_warning)
                .diy_confirmationDialog({
                    //modal: true,
                    overlayCls: '',
                    buttons: [{
                        text: jimdoData.messages.ok,
                        click: function() {
                            $(this).remove();
                        }
                    }]
                });
        });

    }
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/common/js/browserchecks.js
 ** module id = 1143
 ** module chunks = 0
 **/